import { useState, useEffect, useRef, useContext } from "react";
import userImg from "../../assets/img/au.jpg";
import { AdminContext } from "../../context/AdminContext";

const AdminTopbar = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const {handleSidebarToggle, handleLogoutClick} = useContext(AdminContext);

  const {first_name , last_name} = JSON.parse(localStorage.getItem("admin"))
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDropdownToggle = (e) => {
    e.preventDefault();
    setDropdownOpen(!isDropdownOpen);
  };

  const onLogoutClick = (e) => {
    e.preventDefault();
    setDropdownOpen(false);
    handleLogoutClick();
  };

  return (
    <div className="dashboard_topbar">
      <button className="btn btn-light" id="sidebarToggle" onClick={handleSidebarToggle}>
        <i className="bi bi-list"></i>
      </button>

      <div className="searchbar W-100">
        <i className="bi bi-search"></i>
        <input
          type="text"
          className="form-control"
          placeholder="Search for more"
        />
      </div>

      {/* Wrapper for right-side items */}
      <div className="topbar-right-items">
        <div className="notification-bell">
          <i className="bi bi-bell"></i>
          <span className="notification-dot"></span>
        </div>

        <div className="dropdown" ref={dropdownRef}>
          <button
            type="button"
            className="dropdown-toggle text-decoration-none username fw-500 ft-16 lh-24"
            id="dropdownMenuButton"
            onClick={handleDropdownToggle}
            aria-expanded={isDropdownOpen}
            style={{ background: "none", border: "none", padding: 0 }}
          >
            <span className="d-none d-md-inline">{`${first_name} ${last_name}`}</span>
            <span className="userprofileimg">
              <img src={userImg} alt="username" />
            </span>
          </button>

          <ul
            className={`dropdown-menu dropdown-box  ${
              isDropdownOpen ? "show" : ""
            }`}
            aria-labelledby="dropdownMenuButton"
          >
            <li>
              <button
                type="button"
                className="dropdown-item"
                style={{
                  background: "none",
                  border: "none",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                My Profile
              </button>
            </li>
            <li>
              <button
                type="button"
                className="dropdown-item"
                onClick={onLogoutClick}
                style={{
                  background: "none",
                  border: "none",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdminTopbar;
